module.exports = __webpack_public_path__ + "img/72.e19a7a01.jpg";